<template>
  <div class="wrapper" id="fillInfo">
    <div class="contentModule" >
      <div class="space-between theme">
        <div>
          <div class="insuranceTheme">泰康在线车险 - 报价详情</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <el-collapse v-model="retractList">
          <!-- 报价详情 -->
          <el-collapse-item title="报价详情" name="1">
            <ul class="detailedList">
              <li>
                <div class="tit">
                  <span>车牌号码：</span>
                </div>
                <div class="sInfo">{{licenseNo}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>品牌型号：</span>
                </div>
                <div class="sInfo">{{vehicleBrand_vehicleModel}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>发动机号：</span>
                </div>
                <div class="sInfo">{{engineNo}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>车架号：</span>
                </div>
                <div class="sInfo">{{frameNo}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>注册日期：</span>
                </div>
                <div class="sInfo">{{enrollDate}}</div>
              </li>
              <li v-show="chgOwnerFlag == '1'">
                <div class="tit">
                  <span>过户车：</span>
                </div>
                <div class="sInfo">是</div>
              </li>
              <li v-show="chgOwnerFlag == '1'">
                <div class="tit">
                  <span>过户日期：</span>
                </div>
                <div class="sInfo">{{transferDate}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>车主姓名：</span>
                </div>
                <div class="sInfo">{{ownerName}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>燃料 (能源) 种类：</span>
                </div>
                <div class="sInfo">{{fuelType}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>商业险报价号：</span>
                </div>
                <div class="sInfo">{{biQuotationNo}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>商业险保期：</span>
                </div>
                <div class="sInfo">{{biPeriod}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>交强险报价号：</span>
                </div>
                <div class="sInfo">{{ciQuotationNo}}</div>
              </li>
              <li>
                <div class="tit">
                  <span>交强险保期：</span>
                </div>
                <div class="sInfo">{{ciPeriod}}</div>
              </li>
            </ul>
            <div class="commercialInsuranceWrap" v-show="commercialInsuranceWrap">
              <div class="insuranceTitle sectionTitle">
                <div class="vertical"></div>
                <div>商业险</div>
              </div>
              <div class="biList">
                <el-table
                  class="tableTitle"
                  border
                  :data="commercialInsuranceDetailList"
                  style="width: 100%">
                  <el-table-column
                    prop="kindName"
                    label="险别"
                    min-width="49%">
                  </el-table-column>
                  <el-table-column
                    prop="label"
                    label="产品计划"
                    min-width="19%">
                  </el-table-column>
                  <el-table-column
                    prop="kindFlag"
                    label="不计免赔"
                    min-width="15%">
                  </el-table-column>
                  <el-table-column
                    prop="premium"
                    label="保费(元)"
                    min-width="15%">
                  </el-table-column>
                </el-table>
              </div>
              <ul class="detailedList">
                <li class="commercialInsurancePremium">
                  <div>商业险保费合计：</div>
                  <div class="premium"></div>
                  <div class="disCount"></div>
                </li>
                <li class="drivingPassengerInsurancePremium">
                  <div>驾乘保保费合计：</div>
                  <div class="premium"></div>
                  <div class="disCount"></div>
                </li>
                <li class="autoInsuranceExtraPremium">
                  <div class="autoInsuranceExtraName">交强险保费合计：</div>
                  <div class="premium"></div>
                  <div class="disCount"></div>
                </li>
                <li class="vesselTaxPremium">
                  <div >车船税合计：</div>
                  <div class="premium"></div>
                </li>
                <li>
                  <div>费用合计：</div>
                  <div class="totalPremium"></div>
                </li>
                <li class="businessScore" v-show="businessScore">
                  <span>保单综合评分：</span>
                  <span class="businessScoreValue" v-html="businessScore"></span>
                </li>
              </ul>

              <!-- 温馨提示 -->
              <div class="detailedListPrompt">
                <div>温馨提示：</div>
                <div>1.最终保费以实际投保为准；</div>
                <!-- 报价单可分享转投保提示 -->
                <div class="sharePrompt">
                  2.可点击 <span class="copyUrl" data-id="H5">复制链接</span> 分享当前报价给-手机用户。
                </div>
                <div class="sharePrompt">
                  2.可点击 <span class="copyUrl" data-id="PC">复制链接</span> 分享当前报价给-电脑用户。
                </div>
              </div>
              <!-- 立即投保 -->
              <footer class="immediateInsurance" v-show="immediateInsurance">
                <div class="submitBtn-wrap space-around">
                  <button class="nextStep" @click="orders()" data-value="1"
                          onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">立即投保</button>
                </div>
              </footer>
            </div>
          </el-collapse-item>
          <!-- 投保 - 信息填写 -->
          <el-collapse-item class="fillInfo" title="人员信息" name="2" v-show="fillInfoRetract">
            <!-- 车主信息 -->
            <div class="sectionTitle">
              <div class="vertical"></div>
              <div>车主信息</div>
            </div>
            <ul class="ownerInfo">
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>车主名称：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入车主真实姓名" v-model="ownerName" disabled>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>车主手机号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" class="textInput" v-model="ownerMobile" placeholder="请输入11位车主手机号" />
                </div>
              </li>
            </ul>

            <!-- 投保人信息 -->
            <div class="sectionTitle">
              <div class="vertical"></div>
              <div>投保人信息</div>
              <div class="isOwner fr" data-id="isOwner">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_no.png"
                     data-check="0" v-show="isOwner == false">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_yes.png" v-show="isOwner == true"
                     data-check="1" >
                <span>同车主</span>
              </div>
            </div>
            <ul class="insureInfo">
              <li data-id="insureInfo" v-show="isOwner == false">
                <div class="tit">
                  <span class="must">*</span>
                  <span>投保人性质：</span>
                </div>
                <div class="sInfo">
                  <el-select v-model="policyHolder.type" @change="typePicker('insureInfo')" placeholder="请选择使用性质" >
                    <el-option
                      v-for="item in insureTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li v-show="isOwner == false">
                <div class="tit">
                  <span class="must">*</span>
                  <span>投保人名称：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入投保人名称" v-model="policyHolder.name">
                </div>
              </li>
              <li v-show="isOwner == false">
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件类型：</span>
                </div>
                <div class="sInfo idtype">
                  <el-select v-model="policyHolder.idtype" placeholder="请选择证件类型" disabled >
                    <el-option
                      v-for="item in idTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="idCardRecognition" v-show="policyHolder.idtype == 1" @click="idCardRecognition('insureIdCard')">
                  <img src="../../../../../static/images/public/idCardRecognitionIcon.png" />
                  <span>身份证识别</span>
                </div>
              </li>
              <li v-show="isOwner == false">
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件号码：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入投保人证件号码" v-model="policyHolder.idnumber">
                </div>
              </li>
              <li v-show="isOwner == false && policyHolder.idtype != '1'">
                <div class="tit">
                  <span class="must">*</span>
                  <span>注册日期：</span>
                </div>
                <div class="sInfo" >
                  <el-date-picker
                    v-model="policyHolder.brithday"
                    :picker-options="policyHolderBrithdayDisable"
                    value-format="yyyy-MM-dd"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    align="center"
                    placeholder="请选择注册日期"
                    class="my-el-date-picker"
                    :editable="false"
                  >
                  </el-date-picker>
                </div>
              </li>
              <li v-show="isOwner == false">
                <div class="tit">
                  <span class="must">*</span>
                  <span>手机号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" class="textInput" v-model="policyHolder.mobile" placeholder="请输入11位投保人手机号" />
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>电子邮箱：</span>
                </div>
                <div class="sInfo">
                  <input type="text" class="textInput" v-model="policyHolder.email" placeholder="请输入电子邮箱" />
                </div>
              </li>
              <li data-value="440100">
                <div class="tit">
                  <span class="must">*</span>
                  <span>省市区：</span>
                </div>
                <div class="sInfo">
                  <el-cascader
                    v-model="policyHolderProvincesCode"
                    :options="provincesList"
                    :props="{ label: 'label'}"
                    @change="provincePicker($event, 'policyHolder')"
                    ref="provincesCode">
                  </el-cascader>
                </div>
              </li>
              <li class="address">
                <div class="tit">
                  <span class="must">*</span>
                  <span>详细地址：</span>
                </div>
                <div class="sInfo">
                  <textarea maxlength="200" class="textInput" placeholder="请填写您的详细地址，如街道、楼牌号等，文字录入最多200个汉字；" v-model="policyHolder.address"></textarea>
                </div>
              </li>
            </ul>

            <!-- 被保人信息 -->
            <div class="sectionTitle">
              <div class="vertical"></div>
              <div>被保人信息</div>
              <div class="isPolicyHolder fr" data-id="isPolicyHolder">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_no.png"
                     data-check="0" v-show="isPolicyHolder == false">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_yes.png" v-show="isPolicyHolder == true"
                     data-check="1" >
                <span>同投保人</span>
              </div>
              <div class="beIsOwner fr" data-id="beIsOwner">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_no.png"
                     data-check="0" v-show="beIsOwner == false">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_yes.png" v-show="beIsOwner == true"
                     data-check="1" >
                <span>同车主</span>
              </div>
            </div>
            <ul class="beInsureInfo" v-show="!isPolicyHolder && !beIsOwner">
              <li data-id="beInsureInfo">
                <div class="tit">
                  <span class="must">*</span>
                  <span>被保人性质：</span>
                </div>
                <div class="sInfo">
                  <el-select v-model="insuredUser.type" @change="typePicker('beInsureInfo')" placeholder="请选择使用性质" >
                    <el-option
                      v-for="item in beInsureTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>被保人名称：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入被保人名称" v-model="insuredUser.name">
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件类型：</span>
                </div>
                <div class="sInfo idtype">
                  <el-select v-model="insuredUser.idtype" placeholder="请选择证件类型" disabled >
                    <el-option
                      v-for="item in idTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="idCardRecognition" v-show="insuredUser.idtype == 1" @click="idCardRecognition('beInsureIdCard')">
                  <img src="../../../../../static/images/public/idCardRecognitionIcon.png" />
                  <span>身份证识别</span>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件号码：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入被保人证件号码" v-model="insuredUser.idnumber">
                </div>
              </li>
              <li v-show="insuredUser.idtype != '1'">
                <div class="tit">
                  <span class="must">*</span>
                  <span>注册日期：</span>
                </div>
                <div class="sInfo" >
                  <el-date-picker
                    v-model="insuredUser.brithday"
                    :picker-options="insuredUserBrithdayDisable"
                    value-format="yyyy-MM-dd"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    align="center"
                    placeholder="请选择注册日期"
                    class="my-el-date-picker"
                    :editable="false"
                  >
                  </el-date-picker>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>手机号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" class="textInput" v-model="insuredUser.mobile" placeholder="请输入11位被保人手机号" />
                </div>
              </li>
            </ul>

            <!-- 业务经办人信息 -->
            <div class="sectionTitle" v-show="wallahInfoShow">
              <div class="vertical"></div>
              <div>业务经办人信息</div>
            </div>
            <ul class="wallahInfo" v-show="wallahInfoShow">
              <li data-id="wallahInfo">
                <div class="tit">
                  <span class="must">*</span>
                  <span>经办人类别：</span>
                </div>
                <div class="sInfo">
                  <el-select v-model="agent.possesSortType" placeholder="请选择经办人类别" >
                    <el-option
                      v-for="item in wallahTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>经办人名称：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入经办人名称" v-model="agent.name">
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件类型：</span>
                </div>
                <div class="sInfo idtype">
                  <el-select v-model="agent.idtype" placeholder="请选择证件类型" disabled >
                    <el-option
                      v-for="item in idTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="idCardRecognition" v-show="agent.idtype == 1" @click="idCardRecognition('wallahIdCard')">
                  <img src="../../../../../static/images/public/idCardRecognitionIcon.png" />
                  <span>身份证识别</span>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件号码：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="请输入经办人证件号码" v-model="agent.idnumber">
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>手机号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" class="textInput" v-model="agent.mobile" placeholder="请输入11位经办人手机号" />
                </div>
              </li>
            </ul>

            <!-- 发票信息 -->
            <div class="sectionTitle">
              <div class="vertical"></div>
              <div>发票信息</div>
              <div class="isInvoice fr" data-id="isInvoice">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_no.png"
                     data-check="0" v-show="isInvoice == false">
                <img class="checkbox" src="../../../images/dutyInsurance/login/checkbox_yes.png" v-show="isInvoice == true"
                     data-check="1" >
                <span>开发票</span>
              </div>
            </div>
            <ul class="invoiceInfo" v-show="isInvoice">
              <li data-id="invoiceInfo">
                <div class="tit">
                  <span class="must">*</span>
                  <span>纳税人类型：</span>
                </div>
                <div class="sInfo">
                  <el-select @change="universalPicker" v-model="tax.taxpayerType" placeholder="请选择纳税人类型" >
                    <el-option
                      v-for="item in tax.taxpayerType == '0' ? [{label: '个人', value: '0'}] : [{label: '一般纳税人', value: '1'}, {label: '小规模纳税人', value: '2'}]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li data-id="invoiceInfo">
                <div class="tit">
                  <span class="must">*</span>
                  <span>发票类型：</span>
                </div>
                <div class="sInfo">
                  <el-select v-model="tax.receiptType" placeholder="请选择发票类型" >
                    <el-option
                      v-for="item in receiptTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </div>
              </li>
              <li>
                <div class="tit">
                  <span class="must">*</span>
                  <span>证件号码：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onKeyUp="value=value.replace(/[\W]/g,'')" placeholder="同投保人证件号码" v-model="isOwner ? isOwnerList.ownerIdNumber : policyHolder.idnumber" style="background-color: #F5F7FA;" disabled>
                </div>
              </li>
              <li v-show="special">
                <div class="tit">
                  <span class="must">*</span>
                  <span>手机号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" class="textInput" v-model="isOwner ? ownerMobile : policyHolder.mobile" placeholder="同投保人手机号" disabled />
                </div>
              </li>
              <li v-show="special">
                <div class="tit">
                  <span class="must">*</span>
                  <span>银行：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入纳税人银行" v-model="tax.bank">
                </div>
              </li>
              <li v-show="special">
                <div class="tit">
                  <span class="must">*</span>
                  <span>银行账号：</span>
                </div>
                <div class="sInfo">
                  <input type="text" placeholder="请输入纳税人银行账号" v-model="tax.account">
                </div>
              </li>
              <li data-value="440100" v-show="special">
                <div class="tit">
                  <span class="must">*</span>
                  <span>省市区：</span>
                </div>
                <div class="sInfo">
                  <el-cascader
                    v-model="taxProvincesCode"
                    :options="provincesList"
                    :props="{ label: 'label'}"
                    @change="provincePicker($event, 'tax')"
                    ref="provincesCode">
                  </el-cascader>
                </div>
              </li>
              <li class="address" v-show="special">
                <div class="tit">
                  <span class="must">*</span>
                  <span>详细地址：</span>
                </div>
                <div class="sInfo">
                  <textarea maxlength="200" class="textInput" placeholder="请填写您的详细地址，如街道、楼牌号等，文字录入最多200个汉字；" v-model="tax.rAddress"></textarea>
                </div>
              </li>

              <!-- 发票类型 - 纸质发票 -->
              <li data-value="440100" v-show="tax.receiptType == '4'">
                <div class="tit">
                  <span class="must">*</span>
                  <span>省市区：</span>
                </div>
                <div class="sInfo">
                  <el-cascader
                    v-model="policyHolderProvincesCode"
                    :options="provincesList"
                    :props="{ label: 'label'}"
                    @change="provincePicker($event, 'policyHolder')"
                    disabled
                    class="policyHolderProvincesCode"
                    ref="provincesCode">
                  </el-cascader>
                </div>
              </li>
              <li class="address" v-show="tax.receiptType == '4'">
                <div class="tit">
                  <span class="must">*</span>
                  <span>详细地址：</span>
                </div>
                <div class="sInfo">
                  <textarea maxlength="200" class="textInput" placeholder="请填写您的详细地址，如街道、楼牌号等，文字录入最多200个汉字；"
                            v-model="policyHolder.address" style="background-color: #F5F7FA;" disabled></textarea>
                </div>
              </li>

            </ul>
            <!-- 确认下单 -->
            <footer class="immediateInsurance">
              <div class="submitBtn-wrap space-around">
                <button class="nextStep" @click="submitOrder()" data-value="1"
                        onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">确认下单</button>
              </div>
            </footer>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>


    <el-dialog
      title="身份证采集"
      :visible.sync="idCardRecognitionState"
      :with-header="false"
      direction="btt"
      center
    >
      <div class="insuran-con generalWrap">
        <div class="topTips">请把身份证从保护套里拿出来拍照，以免反光影响信息采集的正确率。</div>
        <div class="content">
          <div class="title">拍摄上传身份证人脸页</div>
          <div class="exampleUnit">
            <div class="example">
              <img id="idCardData" src="../../../../../static/images/public/autoInsurance/idCard-1.png" />
            </div>
            <div class="upload">
              <input type="file" data-id="idCardData" accept="image/*" @change="selectIdCard" ref="idCardData" />
            </div>
          </div>
          <div class="norm">拍照请参照以下规范:</div>
          <div class="normList space-between">
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-1.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/right.png" />
                <span>正确</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-2.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>边角缺失</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-3.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>相片模糊</span>
              </div>
            </div>
            <div>
              <div>
                <img class="example" src="../../../../../static/images/public/autoInsurance/idCardExample-4.png" />
              </div>
              <div class="explain">
                <img src="../../../../../static/images/public/autoInsurance/wrong.png" />
                <span>曝光过度</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="healthSubmitBtn" data-index="0" @click="idCardRecognitionState = false">取消</div>
          <div class="healthSubmitBtn" data-index="1" @click="uploadIdCard">立即上传</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import province from "../../../../tool/resource/province";

  export default {
    name: "fillInfo",
    data() {
      return {
        shareToken: null,                   // 分享token
        beShareToken: null,                 // 被分享token
        quoteIdNum: null,                   // 报价订单ID
        eventLogToken: null,                // 事件日志Token
        orderToken: '',                     // 订单token

        retractList: ['1'],
        detailsQuotationRetract: true,      // 报价详情 - 显示/隐藏
        fillInfoRetract: false,             // 人员信息 - 显示/隐藏

        licenseNo: '',
        vehicleBrand_vehicleModel: '',
        engineNo: '',
        frameNo: '',
        enrollDate: '',
        chgOwnerFlag: '0',
        transferDate: '',
        ownerName: '',
        fuelType: '',
        biQuotationNo: '',
        biPeriod: '',
        ciQuotationNo: '',
        ciPeriod: '',
        commercialInsuranceWrap: false,
        commercialInsuranceDetailList: [{}],      // 商业险险种列表
        businessScore: null,              // 保单综合评分

        immediateInsurance: true,         // 是否可以继续投保

        formDataList: {},                 // 已选上传图片集合
        terminal: 4,                      // 终端类型/渠道类型
        isOwner: false,                   // 投保人同车主
        beIsOwner: false,                 // 被保人同车主
        isPolicyHolder: false,            // 被保人同投保人
        // 车主信息
        isOwnerList: {
          ownerName: "",                  // 车主名称
          ownerIdType: "1",               // 车主证件类型
          ownerIdNumber: "",              // 车主证件号码
          ownerType: "1",                 // 车主性质
          ownerBrithday: "",              // 车主生日/注册日期
          ownerSex: "",                   // 车主性别
        },
        ownerMobile: "",                  // 车主手机号
        // 投保人信息
        policyHolder: {
          name: "",                       // 投保人名称
          mobile: "",                     // 投保人手机号码
          idtype: "1",                    // 投保人证件类型
          idnumber: "",                   // 投保人证件号码
          type: "1",                      // 投保人性质
          email: "",                      // 投保人电子邮箱
          brithday: "",                   // 投保人注册日期
          sex: "",                        // 投保人性别
          province: "广东省",              // 投保人省份
          city: "广州市",                  // 投保人城市
          address: "",                    // 投保人详细地址
        },
        policyHolderProvincesCode: '440100',          // 投保人省市区 - 编码
        policyHolderBrithdayDisable: {             // 投保人注册日期 - 期限
          disabledDate(time) {
            const date = new Date(Date.now());
            return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
          },
        },
        // 被保人信息
        insuredUser: {
          name: "",                       // 被保人名称
          mobile: "",                     // 被保人手机号码
          idtype: "1",                    // 被保人证件类型
          idnumber: "",                   // 被保人证件号码
          type: "1",                      // 被保人性质
          brithday: "",                   // 被保人注册日期
          sex: "",                        // 被保人性别
        },
        insuredUserBrithdayDisable: {             // 被保人注册日期 - 期限
          disabledDate(time) {
            const date = new Date(Date.now());
            return time.getTime() > new Date(date - 1 * 24 * 60 * 60 * 1000);
          },
        },
        // 经办人信息
        wallahInfoShow: false,            // 经办人信息 - 是否显示
        agent: {
          name: "",                       // 经办人名称
          mobile: "",                     // 经办人手机号
          idtype: "1",                    // 经办人证件类型
          idnumber: "",                   // 经办人证件号码
          possesSortType: "1",            // 经办人类别
          brithday: "",                   // 经办人注册日期
          sex: "",                        // 经办人性别
        },
        // 发票信息
        isInvoice: false,                   // 是否需要发票
        tax: {
          taxpayerType: "0",              // 纳税人类型
          receiptType: "2",               // 发票类型
          province: "广东省",              // 纳税人省份
          city: "广州市",                  // 纳税人城市
          rAddress: "",                   // 纳税人详细地址
          bank: "",                       // 纳税人开户行
          account: "",                    // 纳税人开户账号
        },
        taxProvincesCode: '440100',       // 纳税人省市区 - 编码
        special: false,                   // 纳税人 - 非个人

        idCardRecognitionState: false,    // 身份证识别 - 弹窗状态
        idCardRecognitionName: '',        // 身份证识别 - 弹窗名称

        provincesList: province.provincesList,
        provinceValue: province.provincesList[0].value,
        provinceLabel: province.provincesList[0].label,
        cityList: province.provincesList[0].children,

        idTypeList: [{label: '身份证', value: '1'}, {label: '统一社会信用代码', value: '6'}],
        insureTypeList: [{label: '个人', value: '1'}, {label: '企业', value: '2'}, {label: '机关/团体', value: '3'}],
        beInsureTypeList: [{label: '个人', value: '1'}, {label: '企业', value: '2'}, {label: '机关/团体', value: '3'}],
        wallahTypeList: [{label: '车辆所有人', value: '1'}, {label: '车辆管理人', value: '2'}, {label: '保险人允许的合法驾驶员', value: '3'}, {label: '其他', value: '9'}],
        receiptTypeList: [{label: '电子普票', value: '2'}, {label: '纸质普票', value: '4'}],
      };
    },
    methods: {
      //-- 事件绑定
      eventBinding() {
        let that = this;

        //-- 找客服 二维码 绑定事件
        $(".customerIcon").on("click", function(){
          window.open('https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f');
        });

        //-- 复制 - 分享url
        $(".copyUrl").off().click(function(){
          let id = $(this).attr('data-id'),
            shareUrl = '',
            { pathname, host } = window.location,
            {shareToken, beShareToken, quoteIdNum, eventLogToken} = that,
            clientDomainPC = host.indexOf('xbyf.xiaobaibao.com') !== -1 ? 'https://xbyf.xiaobaibao.com':'https://xbyftest.xiaobaibao.com',
            clientDomainH5 = host.indexOf('xbyf.xiaobaibao.com') !== -1 ? 'https://mtadmin.xiaobaibao.com/src/pages/product/autoInsurance/fillInfo.html':'https://newtest.xiaobaibao.com/src/pages/product/autoInsurance/fillInfo.html';

          let params = {quoteIdNum, eventLogToken, beShareToken: that.$$.isValidObj(beShareToken) ? beShareToken : shareToken },
            urlPars = that.$$.jsonToUrlParams(params);

          if (id == 'H5'){
            shareUrl = clientDomainH5 + urlPars;
          }else if (id == 'PC'){
            shareUrl = clientDomainPC + pathname + urlPars;
          }

          // 复制 url
          let input = document.createElement('input');
          input.value = shareUrl;
          document.body.appendChild(input);
          input.select();
          let state = document.execCommand("copy");
          that.$$.alert({message: state ? '复制成功' : '复制失败'});
          input.remove();
        });

        //-- 是否勾选 - 投保人-同车主
        $(".isOwner").off().click(function(){
          if (that.isOwner){
            const {type} = that.policyHolder;
            that.wallahInfoShow = type != '1';
            that.taxpayerTypeAlter(type == '1' ? '0' : '1');
          }else {
            const {ownerType} = that.isOwnerList;
            that.wallahInfoShow = ownerType != '1';
            that.taxpayerTypeAlter(ownerType == '1' ? '0' : '1');
          }
          that.isOwner = !that.isOwner;
        });

        //-- 是否勾选 - 被保人-同车主
        $(".beIsOwner").off().click(function(){
          that.beIsOwner = !that.beIsOwner;
          if (that.beIsOwner) that.isPolicyHolder = !that.beIsOwner;
        });

        //-- 是否勾选 - 被保人-同投保人
        $(".isPolicyHolder").off().click(function(){
          that.isPolicyHolder = !that.isPolicyHolder;
          if (that.isPolicyHolder) that.beIsOwner = !that.isPolicyHolder;
        });

        //-- 是否勾选 - 是否需要发票
        $(".isInvoice").off().click(function(){
          that.isInvoice = !that.isInvoice;
        });

      },
      // 身份证识别 - 弹窗
      idCardRecognition(name){
        let that = this;

        that.idCardRecognitionState = true;
        that.idCardRecognitionName = name;
        that.formDataList = {};
        $('.healthSubmitBtn[data-index="1"]').removeClass('on');
        $('.exampleUnit input').val('');
        $(`#idCardData`).attr("src", '../../../../../static/images/public/autoInsurance/idCard-1.png');
      },
      // 身份证识别 - 选择
      selectIdCard(){
        let file = this.$refs.idCardData.files[0];
        this.compressImages(file);
      },
      // 身份证识别 - 上传
      uploadIdCard() {
        let that = this,
          id = that.idCardRecognitionName;

        if (!that.$$.isValidObj(that.formDataList[id])) return;
        that.fileUploadHandler(id);
      },
      //-- 压缩图片
      compressImages(file) {
        let that = this,
          id = that.idCardRecognitionName;

        //-- file>2M照片压缩到2M，file<=2M不压缩 （半身正面照片压缩到200K）
        that.imageConversion.compressAccurately(file, 2048).then(res => {
          res = new File([res], file.name, {type: res.type, lastModified: Date.now()});

          let reader = new FileReader();
          reader.readAsDataURL(res);
          reader.onload = function(event) {
            let base64 = event.target.result;

            $(`#idCardData`).attr("src", base64);
          };

          let formData = new window.FormData(),
            cardSide = '0';
          formData.append("file", res);
          formData.append("formType", '30002');
          formData.append("cardSide", cardSide);
          that.formDataList[id] = formData;

          // 已选图片 - 允许上传识别
          $('.healthSubmitBtn[data-index="1"]').addClass('on');
        });
      },
      // 文件上传 - 识别
      fileUploadHandler(id){
        let that = this,
          formData = that.formDataList[id];

        let formType = formData.get('formType');

        that.$$.loading("识别中...");
        that.$$.request({
          url: that.UrlConfig.upload_attachment_uploadFileByComplex,
          pars: formData,
          requestBody: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              that.$message.success("识别成功！");

              switch (formType) {
                case '30001':{
                  // responseHandler_30001(datas, id);
                  break;
                }
                case '30002':{
                  responseHandler_30002(datas, id);
                  break;
                }
              }
            } else {
              that.$message.error(msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });

        // 身份证识别 -> 响应处理
        function responseHandler_30002(data, id){
          const { name, idCardNumber } = data;

          if(that.$$.isValidObj(idCardNumber)){
            if (id == 'insureIdCard'){
              that.policyHolder.name = name;
              that.policyHolder.idnumber = idCardNumber;
            }else if (id == 'beInsureIdCard'){
              that.insuredUser.name = name;
              that.insuredUser.idnumber = idCardNumber;
            }else if (id == 'wallahIdCard'){
              that.agent.name = name;
              that.agent.idnumber = idCardNumber;
            }

            that.idCardRecognitionState = false;
            that.$message.success("识别成功！");
          }else{
            that.$message.error("未识别到证件号，请重试！");
          }
        }

      },
      // 纳税人类型
      universalPicker(value){
        this.taxpayerTypeAlter(value);
      },
      // 投保人/纳税人 - 省市区
      provincePicker(e, name){
        let that = this,
          {provinceValue, cityList} = that;

        if (provinceValue == e[0]){
          for (let i in cityList){
            const {value, label} = cityList[i];

            if (value == e[1]) {
              if (name == 'policyHolder') that.policyHolder.city = label;
              if (name == 'tax') that.tax.city = label;
            }
          }
        }
      },
      // 投保人/被保人 - 性质
      typePicker(id){
        let that = this;
        if (id == 'insureInfo'){
          const {type} = that.policyHolder;
          that.wallahInfoShow = type != '1';

          that.policyHolder.idtype = type == '1' ? '1' : "6";
          // $(`.${id} .idCardRecognition`).css('display', `${type == '1' ? 'flex' : 'none'}`);

          // 发票 - 纳税人类型
          if (type == '1'){
            that.taxpayerTypeAlter('0');
          }else {
            that.taxpayerTypeAlter('1');
            that.policyHolder.sex = 'O';
          }
        }else if (id == 'beInsureInfo'){
          const {type} = that.insuredUser;
          that.insuredUser.idtype = type == '1' ? '1' : "6";
          // $(`.${id} .idCardRecognition`).css('display', `${value == '1' ? 'flex' : 'none'}`);

          if (type != '1') that.insuredUser.sex = 'O';
        }
      },
      // 纳税人类型 - 改变发票类型
      taxpayerTypeAlter(value) {
        let that = this,
          {receiptType} = that.tax;

        if (value == '0'){
          that.tax.taxpayerType = '0';
        }else if (value == '1'){
          that.tax.taxpayerType = '1';

          that.receiptTypeList = [{label: '增值税专用发票', value: '3'}];
          that.special = true;
          that.tax.receiptType = '3';
        }else if (value == '2'){
          that.tax.taxpayerType = '2';
        }

        if ((value == '0' || value == '2') && receiptType == '3'){
          that.receiptTypeList = [{label: '电子普票', value: '2'}, {label: '纸质普票', value: '4'}];
          that.special = false;
          that.tax.receiptType = '2';
        }
      },
      // 立即投保
      orders(){
        let that = this;
        that.retractList = ['2'];
        that.fillInfoRetract = true;
        that.immediateInsurance = false;
      },
      // 报价详情
      getQuotation(){
        let that = this;
        that.axios.post('/management/quotecarinsurance/getQuotation',{
          quoteIdNum: that.quoteIdNum,
          beShareToken: that.beShareToken,
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            const {car, isLockMsg} = data['datas'];
            // if (that.$$.isValidObj(isLockMsg)) that.$message.error(isLockMsg);

            responseHandler(data['datas']);
          } else {
            that.$message.error(data.msg);
          }
        });

        function responseHandler(data) {
          const {car, bi, ci, ri, tax, orderToken, orderId, orderStatus, relation, sumPremium, businessScore} = data,
            {provinceLabel, cityList} = that;
          let timestamp = new Date().getTime();

          that.orderToken = orderToken;
          Object.assign(that.$data, car);

          // 车辆信息
          const {licenseNo, engineNo, frameNo, enrollDate, chgOwnerFlag, transferDate, ownerName, ownerIdtype, ownerIdnumber, ownerType, ownerBrithday, ownerSex, fuelType, vehicleBrand, vehicleModel, insuredCode} = car;

          // 燃料 (能源) 种类：
          let fuelTypeList = [{label: '燃油', value: '0'}, {label: '纯电动', value: '1'}, {label: '燃料电池', value: '2'}, {label: '插电式混合动力', value: '3'}, {label: '其他混合动力', value: '4'}, {label: '其他', value: '9'}];
          if (!that.$$.isValidObj(fuelType)) that.fuelType = '燃油';
          for (let i in fuelTypeList){
            const {label, value} = fuelTypeList[i];
            if (fuelType == value) that.fuelType = label;
          }

          // 品牌型号
          that.vehicleBrand_vehicleModel = `${vehicleBrand}${vehicleModel}`;

          // 车主信息
          that.isOwnerList = {
            ownerName,                       // 车主名称
            ownerIdType: ownerIdtype,        // 车主证件类型
            ownerIdNumber: ownerIdnumber,    // 车主证件号码
            ownerType,                       // 车主性质
            ownerBrithday,                   // 车主生日/注册日期
            ownerSex,                        // 车主性别
          };

          // 商业险
          if (that.$$.isValidObj(bi) && that.$$.isValidMap(bi)){
            that.commercialInsuranceWrap = true;

            const {disCount, list, startTime, endTime, premium, quotationNo} = bi;
            let amounts = '';

            if (!that.$$.isValidMap(list)) return;

            // 商业险保期
            that.biPeriod = `${startTime} 至 ${endTime}`;

            // 商业险报价号
            that.biQuotationNo = quotationNo;

            for (let i in list){
              let {amount, kindName, deductibleRate, kindCode, premium, quantity, kindFlag} = list[i];

              if ('104,115,79,204'.includes(kindCode)){
                amounts = that.unitConversion(amount) + '元/座*' + quantity + '座';
              }else {
                amounts = that.unitConversion(amount);
              }

              // 增值服务险别
              if ('74,75,76,77,274,275,276,277'.includes(kindCode)) {
                amounts = `${quantity}次`;
              }

              // 附加绝对免赔率特约险
              if ('701,702,703,704,705'.includes(kindCode)) {
                amounts = `${(deductibleRate * 100)}%`;
              }

              // 商业险 - 险种列表
              that.commercialInsuranceDetailList[i] = {
                kindName,
                label: amounts,
                kindCode,
                quantity,
                kindFlag: that.$$.isValidObj(kindFlag) && kindFlag == '1' ? '√':'',
                premium: premium == '0' ? '0:00' : premium,
              };
            }

            // 商业险保费合计
            $('.commercialInsurancePremium').show().find('.premium').html('￥' + premium);

            // 险种起始时间小于当前时间，当前报价单不能转投保
            let startTimeTimestamp = new Date(startTime).getTime();
            if (startTimeTimestamp < timestamp) that.immediateInsurance = false;
          }

          // 驾乘保
          if (that.$$.isValidObj(ri) && that.$$.isValidMap(ri)){
            const {premium} = ri;
            // 保费合计
            $('.drivingPassengerInsurancePremium').show().find('.premium').html('￥' + premium);
          }

          // 交强险
          if (that.$$.isValidObj(ci) && that.$$.isValidMap(ci)){
            const {disCount, premium, startTime, endTime, tax, quotationNo} = ci;

            // 交强险保期
            that.ciPeriod = `${startTime} 至 ${endTime}`;

            // 交强险报价号
            that.ciQuotationNo = quotationNo;

            // 交强险保费合计
            $('.autoInsuranceExtraPremium').show().find('.premium').html('￥' + premium);

            // 车船税
            if (that.$$.isValidObj(tax) && parseFloat(tax) > 0) $('.vesselTaxPremium').show().find('.premium').html('￥' + tax);

            // 险种起始时间小于当前时间，当前报价单不能转投保
            let startTimeTimestamp = new Date(startTime).getTime();
            if (startTimeTimestamp < timestamp) that.immediateInsurance = false;
          }

          // 发票
          if(that.$$.isValidObj(tax) && that.$$.isValidMap(tax)){
            const {taxpayerType, receiptType, rAddress, bank, account} = tax;

            that.isInvoice = true;

            // 地址
            if (that.$$.isValidObj(rAddress)){
              let add = rAddress.replace('广东省', ''),
                city = add.substr(0, 3),
                adds = add.split(city)[1];
              that.tax.rAddress = adds;

              // 省市区
              for (let i in cityList){
                const {label, value} = cityList[i];

                if (city == label){
                  that.tax.province = provinceLabel;
                  that.tax.city = label;
                  that.tax.taxProvincesCode = value;
                }
              }
            }

            // 发票 - 纳税人类型
            that.taxpayerTypeAlter(taxpayerType);

            // 发票类型 - 纸质普票
            if (receiptType == '4'){
              that.tax.receiptType = receiptType.toString();
            }

          }

          // 费用合计
          $('.totalPremium').html('￥' + sumPremium);

          // 保单综合评分
          that.businessScore = that.$$.isValidObj(businessScore) ? businessScore : null;

          // 订单状态
          if(that.$$.isValidObj(orderId) && that.$$.isValidObj(orderStatus)){
            if (orderStatus == 0 || orderStatus == 8) {
              that.retractList = ['2'];
              that.fillInfoRetract = true;
              that.immediateInsurance = false;
            }

            // 投保单回填
            that.getQuotationDes();
          }
        }
      },
      // 投保单回填
      getQuotationDes(){
        let that = this,
          {quoteIdNum, beShareToken, cityList, wallahTypeList, provinceLabel} = that;

        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_getRelationInfo,
          pars: {
            quoteIdNum,
            beShareToken,
          },
          requestBody: true,
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              responseHandler(datas);
            } else {
              that.$message.error(msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });

        function responseHandler(datas) {
          const {relation} = datas;

          // 投保信息
          if (that.$$.isValidObj(relation)){
            let {carOwner, policyHolder, insuredUser, agent} = relation;

            // 车主信息
            that.ownerMobile = carOwner.mobile;

            // 投保人信息
            if (that.$$.isValidObj(policyHolder) && that.$$.isValidMap(policyHolder)){
              let {relationName, mobile, idnumber, email, address, relationNature, province, city, relationBrithday} = policyHolder;

              that.policyHolder.name = relationName;
              that.policyHolder.idnumber = idnumber;
              that.policyHolder.mobile = mobile;
              that.policyHolder.email = email;
              that.policyHolder.typ = relationNature;
              that.policyHolder.address = address;

              // 注册日期
              if (relationNature != '1' && that.$$.isValidObj(relationBrithday)) {
                that.policyHolder.brithday = relationBrithday;
              }

              // 性质
              that.typePicker('insureInfo');

              // 省市区
              for (let i in cityList){
                const {label, value} = cityList[i];

                if (label == city){
                  that.policyHolder.province = provinceLabel;
                  that.policyHolder.city = label;
                  that.policyHolderProvincesCode = value;
                }
              }

            }

            // 被投保人信息
            if (that.$$.isValidObj(insuredUser) && that.$$.isValidMap(insuredUser)){
              let {relationName, mobile, idnumber, relationNature, relationBrithday} = insuredUser;

              that.insuredUser.name = relationName;
              that.insuredUser.idnumber = idnumber;
              that.insuredUser.mobile = mobile;

              // 注册日期
              if (relationNature != '1' && that.$$.isValidObj(relationBrithday)) {
                that.insuredUser.brithday = relationBrithday;
              }

              // 性质
              that.typePicker('beInsureInfo');
            }

            // 业务经办人信息
            if (policyHolder.relationNature != '1') {
              let {relationName, mobile, idnumber, relationNature} = agent;

              that.wallahInfoShow = true;
              that.agent.name = relationName;
              that.agent.idnumber = idnumber;
              that.agent.mobile = mobile;

              // 性质
              for (let i in wallahTypeList){
                const {label, value} = wallahTypeList[i];

                if (value == relationNature) {
                  that.agent.possesSortType = relationNature;
                }
              }

            }
          }
        }

      },
      // 确认下单
      submitOrder(){
        let that = this,
          {
          beShareToken,                   // 分享token
          quoteIdNum,                     // 报价订单ID
          eventLogToken,                   // 事件日志Token
          terminal,                       // 终端类型/渠道类型
          isOwner,                        // 投保人同车主
          beIsOwner,                      // 被保人同车主
          isPolicyHolder,                 // 被保人同投保人
          // 车主信息
          isOwnerList: {
            ownerName,                  // 车主名称
            ownerIdType,                // 车主证件类型
            ownerIdNumber,              // 车主证件号码
            ownerType,                  // 车主性质
            ownerBrithday,              // 车主生日/注册日期
            ownerSex,                   // 车主性别
          },
          ownerMobile,                  // 车主手机号
          policyHolder,
          insuredUser,
          agent,
          isInvoice,                      // 是否需要发票
          tax,
        } = that;

        // 公司名称
        let // 投保人
          insureName = policyHolder.name,
          insureIdNumber = policyHolder.idnumber,
          insureBrithday = policyHolder.brithday,
          insurePhone = policyHolder.mobile,
          insureEmail = policyHolder.email,
          insureAddress = policyHolder.address,
          // 被保人
          beInsureName = insuredUser.name,
          beInsureIdNumber = insuredUser.idnumber,
          beInsureBrithday = insuredUser.brithday,
          beInsurePhone = insuredUser.mobile,
          // 业务经办人
          wallahName = agent.name,
          wallahIdNumber = agent.idnumber,
          wallahPhone = agent.mobile,
          // 发票
          invoiceBank = tax.bank,
          invoiceAccount = tax.account,
          invoiceAddress = tax.rAddress;

        let params = {
          beShareToken,
          quoteIdNum,
          terminal,
        };

        //-- 校验
        const errorMsg = validationForm();
        if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

        // 数据校验
        function validationForm(){
          let phoneReg = /^0?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/,
            creditReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,   // 统一社会信用代码正则
            bankNumReg = /^[0-9]{1,20}$/, // 银行账户校验
            emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;     // 邮箱正则

          // 车主电话
          if(!that.$$.isValidObj(ownerMobile)) return "请输入11位车主手机号!";
          if(!phoneReg.test(ownerMobile)) return "车主手机号码格式不正确~";
          params.ownerMobile = ownerMobile;

          // 投保人 - 是否同车主
          if (isOwner == false){
            let {idtype, type, sex} = policyHolder;
            let birthday;

            if(!that.$$.isValidObj(insureName)) return "请输入投保人名称~";
            if (!that.$$.constant.chineseNameReg.test(insureName)) return "投保人姓名格式不正确~";

            if(!that.$$.isValidObj(insureIdNumber)) return "请输入投保人证件号码~";

            if (idtype == '1') {
              if (!that.$$.constant.beInsureIdTypeOneReg.test(insureIdNumber)) return "投保人身份证号码格式有误~";

              // 投保人 - 身份证是否大于18岁
              birthday = that.$$.getCardBirthday(insureIdNumber);
              that.verifyMinors(birthday);
            }else if (idtype == '6') {
              if (!creditReg.test(insureIdNumber)) return "投保人证件号码格式有误~";

              if(!that.$$.isValidObj(insureBrithday)) return "请选择投保人注册日期~";
              birthday = insureBrithday;
            }

            if(!that.$$.isValidObj(insurePhone)) return "请输入11位投保人手机号~";
            if(!phoneReg.test(insurePhone)) return "投保人手机号码格式不正确~";

            params.policyHolder = {
              name: insureName,                   // 投保人名称
              mobile: insurePhone,                // 投保人手机号码
              idtype: idtype,                     // 投保人证件类型
              idnumber: insureIdNumber,           // 投保人证件号码
              type: type,                         // 投保人性质
              email: insureEmail,                 // 投保人电子邮箱
              brithday: birthday,                 // 投保人生日/注册日期
              sex: sex,                           // 投保人性别
            }
          }else {
            params.policyHolder = {
              name: ownerName,                    // 车主名称
              mobile: ownerMobile,                // 车主手机号码
              idtype: ownerIdType,                // 车主证件类型
              idnumber: ownerIdNumber,            // 车主证件号码
              type: ownerType,                    // 车主性质
              email: insureEmail,                 // 车主电子邮箱
              brithday: ownerBrithday,            // 车主生日/注册日期
              sex: ownerSex,                      // 车主性别
            }
          }

          if(!that.$$.isValidObj(insureEmail)) return "请输入投保人电子邮箱~";
          if(!emailReg.test(insureEmail)) return "投保人电子邮箱格式不正确~";

          if(!that.$$.isValidObj(insureAddress)) return "请填写投保人的详细地址~";

          params.policyHolder.email = insureEmail;
          params.policyHolder.isOwner = isOwner;
          params.policyHolder.province = policyHolder.province;
          params.policyHolder.city = policyHolder.city;
          params.policyHolder.address = insureAddress;

          // 被保人 - 同车主，(被保人 - 同投保人 && 投保人 - 同车主)
          if (beIsOwner || (isPolicyHolder && isOwner)){
            params.insuredUser = {
              name: ownerName,                    // 车主名称
              mobile: ownerMobile,                // 车主手机号码
              idtype: ownerIdType,                // 车主证件类型
              idnumber: ownerIdNumber,            // 车主证件号码
              type: ownerType,                    // 车主性质
              brithday: ownerBrithday,            // 车主生日/注册日期
              sex: ownerSex,                      // 车主性别
            }
            // 被保人 - 同投保人
          }else if (isPolicyHolder){
            let {idtype, type, sex} = policyHolder;
            let birthday;

            if (idtype == '1') {
              birthday = that.$$.getCardBirthday(insureIdNumber);
            }else if (idtype == '6') {
              birthday = insureBrithday;
            }

            params.insuredUser = {
              name: insureName,                   // 投保人名称
              mobile: insurePhone,                // 投保人手机号码
              idtype: idtype,                     // 投保人证件类型
              idnumber: insureIdNumber,           // 投保人证件号码
              type: type,                         // 投保人性质
              brithday: birthday,                 // 投保人生日/注册日期
              sex: sex,                           // 投保人性别
            }
          }else {
            let {idtype, type, sex} = insuredUser;
            let birthday;

            if(!that.$$.isValidObj(beInsureName)) return "请输入被保人名称~";
            if (!that.$$.constant.chineseNameReg.test(beInsureName)) return "被保人姓名格式不正确~";

            if(!that.$$.isValidObj(beInsureIdNumber)) return "请输入被保人证件号码~";
            if (idtype == '1') {
              if (!that.$$.constant.beInsureIdTypeOneReg.test(beInsureIdNumber)) return "被保人身份证号码格式有误~";

              // 被保人 - 身份证是否大于18岁
              birthday = that.$$.getCardBirthday(beInsureIdNumber);
              that.verifyMinors(birthday);
            }else if (idtype == '6') {
              if (!creditReg.test(beInsureIdNumber)) return "被保人证件号码格式有误~";

              if(!that.$$.isValidObj(beInsureBrithday)) return "请选择被保人注册日期~";
              birthday = beInsureBrithday;
            }

            if(!that.$$.isValidObj(beInsurePhone)) return "请输入11位被保人手机号~";
            if(!phoneReg.test(beInsurePhone)) return "被保人手机号码格式不正确~";

            params.insuredUser = {
              name: beInsureName,                 // 被保人名称
              mobile: beInsurePhone,              // 被保人手机号码
              idtype: idtype,                     // 被保人证件类型
              idnumber: beInsureIdNumber,         // 被保人证件号码
              type: type,                         // 被保人性质
              brithday: birthday,                 // 被保人生日/注册日期
              sex: sex,                           // 被保人性别
            }
          }
          params.insuredUser.isOwner = beIsOwner;
          params.insuredUser.isPolicyHolder = isPolicyHolder;

          // 业务经办人
          if ((!isOwner && policyHolder.type != '1') || (isOwner && ownerIdType != '1')){
            let {idtype, possesSortType} = agent;

            if(!that.$$.isValidObj(wallahName)) return "请输入经办人名称~";
            if (!that.$$.constant.chineseNameReg.test(wallahName)) return "经办人姓名格式不正确~";

            if(!that.$$.isValidObj(wallahIdNumber)) return "请输入经办人证件号码~";
            if (idtype == '1') {
              if (!that.$$.constant.beInsureIdTypeOneReg.test(wallahIdNumber)) return "经办人身份证号码格式有误~";

              // 经办人 - 身份证是否大于18岁
              let birthday = that.$$.getCardBirthday(wallahIdNumber);
              that.verifyMinors(birthday);
            }else if (idtype == '6') {
              if (!creditReg.test(wallahIdNumber)) return "经办人证件号码格式有误~";
            }

            if(!that.$$.isValidObj(wallahPhone)) return "请输入11位经办人手机号~";
            if(!phoneReg.test(wallahPhone)) return "经办人手机号码格式不正确~";

            params.agent = {
              name: wallahName,                   // 经办人名称
              mobile: wallahPhone,                // 经办人手机号码
              idtype: idtype,                     // 经办人证件类型
              idnumber: wallahIdNumber,           // 经办人证件号码
              possesSortType,                     // 经办人性质
            }
          }

          let {taxpayerType, receiptType, province, city} = tax;
          if (isInvoice){
            params.tax = {
              taxpayerType,
              receiptType,
            };

            if (receiptType == '3'){
              if(!that.$$.isValidObj(invoiceBank)) return "请输入纳税人银行~";
              if(!that.$$.isValidObj(invoiceAccount)) return "请输入纳税人银行账号~";
              if(!that.luhnCheck(invoiceAccount)) return "银行账号输入有误,请重新输入~";

              if(!that.$$.isValidObj(invoiceAddress)) return "请填写发票的详细地址~";

              params.tax = {
                taxpayerType,
                receiptType,
                bank: invoiceBank,
                account: invoiceAccount,
                province,
                city,
                rAddress: invoiceAddress,
              }
            }
          }
        }

        // console.log(params);
        // return;
        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_quoteToOrder,
          pars: params,
          requestBody: true,
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              that.$message.success('报价成功~');

              let data = {};
              if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
              if (that.$$.isValidObj(eventLogToken)) data['eventLogToken'] = eventLogToken;
              if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;

              that.$router.push({path: '/taiKang/orderDetail', query: data});
            } else {
              const error_codes = {
                E0001: "token参数异常，请重新投保！",
                E0002: "订单不存在！",
                E0003: "订单已经不可修改！",
                E0004: "当前产品已下架，请重新选择产品投保！",
              };

              let msg = data.msg,
                errorMsgForCode = error_codes[msg];
              errorMsgForCode = that.$$.changeIsNilVal(errorMsgForCode, msg);
              that.$message.error(errorMsgForCode);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });
      },
      // 判断 身份证是否大于18岁
      verifyMinors(insureBirthday) {
        const now_Date = new Date();
        const insureBirthday_Date = new Date(insureBirthday.replace(/-/g,'/'));
        const year = now_Date.getFullYear() - insureBirthday_Date.getFullYear();
        const month = (now_Date.getMonth() + 1) - (insureBirthday_Date.getMonth() + 1);
        const date = now_Date.getDate() - insureBirthday_Date.getDate();
        if (year < 18 || (year == 18 && month <= 0 && date < 0 )) return '投保人年龄必须大于18周岁';
      },
      // 数值转化 - 万
      unitConversion(num) {
        if (num.toString().includes('.')) return num;
        num = Number(num);
        if (num < 10000) {
          return num + '';
        } else {
          return (num / 10000) + '万';
        }
      },
      //银行卡号码检测
      luhnCheck(bankno) {
        let lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）
        let first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
        let newArr = new Array();
        for (let i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
          newArr.push(first15Num.substr(i, 1));
        }
        let arrJiShu = new Array(); //奇数位*2的积 <9
        let arrJiShu2 = new Array(); //奇数位*2的积 >9
        let arrOuShu = new Array(); //偶数位数组
        for (let j = 0; j < newArr.length; j++) {
          if ((j + 1) % 2 == 1) { //奇数位
            if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
            else arrJiShu2.push(parseInt(newArr[j]) * 2);
          } else //偶数位
            arrOuShu.push(newArr[j]);
        }

        let jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
        let jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
        for (let h = 0; h < arrJiShu2.length; h++) {
          jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
          jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
        }

        let sumJiShu = 0; //奇数位*2 < 9 的数组之和
        let sumOuShu = 0; //偶数位数组之和
        let sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
        let sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
        let sumTotal = 0;
        for (let m = 0; m < arrJiShu.length; m++) {
          sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
        }

        for (let n = 0; n < arrOuShu.length; n++) {
          sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
        }

        for (let p = 0; p < jishu_child1.length; p++) {
          sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
          sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
        }
        //计算总和
        sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

        //计算luhn值
        let k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
        let luhn = 10 - k;

        return lastNum == luhn;
      },
      //-- 获取分享token
      createShareToken() {
        let that = this;

        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_createShareToken,
          method : 'GET',
          sfn: function (data) {

            const { success, msg, datas } = data;
            if (success) {
              const {shareToken, requestToken} = data['datas'];
              that.shareToken = shareToken;

              if (!that.$$.isValidObj(that.eventLogToken)) {
                let id = decodeURIComponent(encodeURIComponent(requestToken).replace(new RegExp("%20","gm"),"%2B"));
                that.eventLogToken = id;

                // 修改 - URL全部参数
                let { origin, pathname } = window.location,
                  {beShareToken, quoteIdNum} = that,
                  params = {quoteIdNum, eventLogToken: id};

                if (that.$$.isValidObj(beShareToken)) params[beShareToken] = beShareToken;
                let urlPars = that.$$.jsonToUrlParams(params),
                  url = origin + pathname + urlPars;
                history.pushState("", "", url);

                // 产品屏幕录制
                that.recording();
              }
            } else {
              that.$message.error(msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });
      },
      // 产品屏幕录制
      recording(){
        let that = this;
        let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
        if (that.$$.isValidObj(eventLogToken)) {
          that.screenRecBase.startLoad();
          that.eventLogToken = eventLogToken;
        }
      },

    },
    mounted() {
      let that = this,
        quoteIdNum = that.$route.query.quoteIdNum,
        eventLogToken = that.$route.query.eventLogToken,
        beShareToken = that.$route.query.beShareToken;

      if (that.$$.isValidObj(beShareToken)) that.beShareToken = beShareToken;
      if (that.$$.isValidObj(quoteIdNum)) {
        let id = decodeURIComponent(encodeURIComponent(quoteIdNum.toString()).replace(new RegExp("%20","gm"),"%2B"));
        that.quoteIdNum = id;
        that.getQuotation();
      }

      if (that.$$.isValidObj(eventLogToken)) {
        that.eventLogToken = eventLogToken;

        // 产品屏幕录制
        that.recording();
      }

      // 事件绑定
      that.eventBinding();

      // 获取 - 分享token
      that.createShareToken();

    }
  }
</script>

<style scoped>
  @import "../../../../../static/css/dutyInsurance/fillInfo.css";

  .wrapper{
    overflow-x: auto;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  /deep/ .el-collapse-item__content{
    padding: 10px;
  }

  /deep/ .el-collapse-item__header{
    background-color: #f2f2f2;
    color: #727272;
    font-weight: bold;
    font-size: 16px;
    padding-left: 10px;
    border-bottom: 1px solid #ffffff;
  }

  .detailedList{
    border-bottom: 3px solid #f2f2f2;
  }

  .detailedList>li{
    position: relative;
    width: 49%;
    padding: 5px 0;
    color: #606266;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    font-size: 13px;
  }

  .tit {
    width: 120px;
    color: #000;
    letter-spacing: 1px;
    display: inline-block;
    text-align: right;
  }
  .sInfo {
    height: 100%;
    line-height: 30px;
    color: #ff7052;
    display: inline-block;
    position: relative;
  }

  .insuranceTitle{
    background: #ffffff!important;
  }

  .sectionTitle{
    padding: 10px;
    background: #f2f2f2;
    border-bottom: 2px solid #ffffff;
  }
  .sectionTitle div {
    display: inline-block;
    vertical-align: middle;
    -webkit-line-clamp: 1;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .sectionTitle .vertical {
    width: 3px;
    height: 15px;
    background: #FF7052;
    border-radius: 3px;
  }

  .biList /deep/ .el-table th{
    background: #f2f2f2;
  }

  .biList /deep/ .el-table td,
  .biList /deep/ .el-table th{
    padding: 10px 0;
  }

  .commercialInsurancePremium,
  .drivingPassengerInsurancePremium,
  .autoInsuranceExtraPremium,
  .vesselTaxPremium{
    display: none;
  }

  .detailedList{
    padding: 8px;
    font-size: 14px;
    border-bottom: 3px solid #f2f2f2;
  }
  .detailedList li{
    padding: 5px 0;
  }
  .detailedList li>div{
    display: inline-block;
    vertical-align: middle;
  }
  .detailedList li>div:nth-child(2){
    color: #ff7052;
  }

  .detailedList li span{
    display: inline-block;
  }
  .totalPremium {
    font-weight: bold;
  }

  .detailedListPrompt{
    color: #ff7052;
    font-size: 12px;
    font-weight: bold;
    padding: 8px;
  }
  .detailedListPrompt div:not(:first-child){
    padding-left: 3px;
  }
  .sharePrompt span{
    color: #4662d9;
  }

  .immediateInsurance{
    margin: 0 auto;
    padding: 1rem 0;
  }

  .must {
    color: #FF7052;
    display: inline-block;
  }

  .fillInfo .sInfo{
    line-height: 50px;
  }

  .fillInfo ul{
    padding: 10px 0;
  }

  .insureInfo{
    padding: 3rem 0;
  }

  .beInsureInfo>li,
  .insureInfo>li,
  .wallahInfo>li,
  .invoiceInfo>li{
    position: relative;
    width: 49%;
    height: 50px;
    padding: 5px 0;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    font-size: 13px;
  }

  input{
    width: 260px;
    height: 39px;
    padding: 0 5px;
    font-size: 14px;
    box-sizing: border-box;
    color: #ff7052;
    display: inline-block;
    outline: none;
    -webkit-appearance: none;
    -webkit-box-sizing: border-box;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }

  .section input::-webkit-input-placeholder {
    font-size: 14px!important;
  }

  .section /deep/ .el-input__inner,
  .section /deep/ .el-select,
  .section /deep/ .el-cascader{
    width: 260px;
    color: #ff7052;
  }

  .idtype,
  .idtype /deep/ .el-input__inner,
  .idtype /deep/ .el-select{
    width: 160px;
  }

  textarea{
    width: 260px;
    height: 100%;
    line-height: 150%;
    color: #FF7052;
    padding: 0.625rem;
    resize: none;
    border-radius: 0.375rem;
    border: 1px solid #c9ccd4;
  }

  .address{
    height: 66px!important;
  }
  .address .tit{
    vertical-align: middle;
  }
  .address textarea {
    outline: none;
    resize: none;
    padding: 5px;
    height: 66px;
    border-radius: 5px;
    color: #ff7052;
    vertical-align: middle;
  }

  .policyHolderProvincesCode input{
    background-color: #F5F7FA;
  }

  .isPolicyHolder{
    padding-left: 15px;
  }

  .idCardRecognition{
    font-size: 12px;
    color: #ff7052;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    text-align: right;
  }

  .idCardRecognition img{
    width: 23px;
    height: 23px;
    display: inline-block;
  }

  .businessScore{
    width: 100% !important;
    border-top: 1px solid #E5E5E5;
  }
  .businessScoreValue{
    color: #ff7052;
    font-weight: bold;
  }

  /* 弹窗 */
  .generalWrap .insuran-con{
    /*background-color: #F2F2F2;*/
    height: 100vh;
    padding-bottom: 0!important;
  }
  .generalWrap .headline{
    text-align: center;
    font-size: 16px;
    line-height: 50px;
    border-bottom: 1px solid #f5f5f5;
  }
  .generalWrap .topTips{
    color: #ff6503;
    background-color: #fbf0e2;
    padding: 5px 4%;
    margin: 10px 10px 0;
    font-size: 12px;
  }
  .generalWrap .content{
    background-color: white;
    text-align: center;
  }
  .generalWrap .content .title{
    font-size: 16px;
    margin: 30px auto 20px;
  }

  .generalWrap .content .exampleUnit{
    width: 16rem;
    height: 10rem;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  .generalWrap .content .upload{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    background: #fff;
    z-index: 999;
    overflow: hidden;
  }
  .generalWrap .content .upload>input{
    opacity: 0;
    width: 100%;
    height: 100%;
  }

  .generalWrap .content .norm{
    margin: 20px auto;
    color: #999999;
  }
  .generalWrap .content .normList{
    padding: 0 8px;
    color: #999999;
  }
  .generalWrap .content .normList>div{
    width: 25%;
    padding: 0 1px;
  }
  .generalWrap .content .normList .example{
    width: 100%;
    background: #fff;
    border: 0.013333rem solid #f1b207;
  }
  .generalWrap .content .normList .explain{
    color: #999999;
    padding-top: 3px;
    position: relative;
  }
  .generalWrap .content .normList .explain img{
    width: 1.3rem;
    display: inline-block;
    vertical-align: middle;
  }
  .generalWrap .content .normList .explain span{
    display: inline-block;
    vertical-align: middle;
    margin-left: -3px;
  }


  .generalWrap .healthSubmitBtn{
    width: calc(49% - 2em);
    margin: 2em 1em;
    text-align: center;
    background-color: #e8e7e7;
    color: white;
    font-size: 1.2em;
    padding: .6em 0;
    border-radius: .5em;
    display: inline-block;
  }
  .healthSubmitBtn.on{
    background-color: #ff7052;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/autoInsurance/taikang/fillInfo.vue